module.exports = __webpack_public_path__ + "static/media/CONECTOR.e01b771c.jpg";